import { Link } from "react-router";
import styles from "./SectionHeader.module.css";

/**
 * `id` lands on the heading so a section can point at it with aria-labelledby.
 * `aside` and `link` switch to a split header: the heading on the left, one line and a
 * link on the right, so every section ends its header with somewhere to go next.
 * `controls` (a carousel's arrows, say) sit at the far end of the link's line.
 */
export default function SectionHeader({
  id,
  eyebrow,
  title,
  text,
  aside,
  link,
  controls,
  center = false,
  as: Tag = "h2",
}) {
  const heading = (
    <>
      {eyebrow ? <p className="eyebrow">{eyebrow}</p> : null}
      <Tag id={id}>{title}</Tag>
      {text ? <p className={styles.text}>{text}</p> : null}
    </>
  );
  if (!aside && !link && !controls) {
    return (
      <div className={`${styles.header} ${center ? styles.center : ""}`.trim()}>{heading}</div>
    );
  }
  const linkElement = link ? (
    <Link to={link.to} className={styles.link}>
      {link.label}
    </Link>
  ) : null;
  return (
    <div className={`${styles.header} ${styles.split}`}>
      <div className={styles.main}>{heading}</div>
      <div className={styles.aside}>
        {aside ? <p className={styles.asideText}>{aside}</p> : null}
        {controls ? (
          <div className={styles.linkRow}>
            {linkElement}
            {controls}
          </div>
        ) : (
          linkElement
        )}
      </div>
    </div>
  );
}
